import { TimelineGraphWrapper } from './wrapper';
import { TimelineGraphKnobs } from './knobs';
import { timeline, stackedTimeline } from 'widgets/endpoints';
import { PropertyType as SrsPropertyType, PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { filterProperties } from 'utilities/srsUtils';
import { DefaultChartColorScales } from 'styles/chartColors';

const types = [SrsPropertyType.Temporal];

export const config = {
	key: 'TIMELINE',
	label: 'Timeline',
	icon: 'timeline-area-chart',
	wrapper: TimelineGraphWrapper,
	endpoint: timeline,
	Knobs: TimelineGraphKnobs,
	types: types,
	createDefaultOptions: (filteredProperties) => {
		return {
			options: {
				propertyList: [filteredProperties[0].name],
				parameters: {
					maxBinResolution: 'Day',
					maxMajorBinCount: 1,
					maxMinorBinCount: 32,
				},
			},
		};
	},
	createDefaultConfiguration: (_filteredProperties) => {
		return {
			stacked: false,
		};
	},
	isValid: (selectedDefinitionName) => {
		return filterProperties(selectedDefinitionName, [], types).length >= 1;
	},
};

export const stackedConfig = {
	key: 'STACKED_TIMELINE',
	label: 'Stacked Timeline',
	icon: 'timeline-area-chart',
	wrapper: TimelineGraphWrapper,
	endpoint: stackedTimeline,
	Knobs: TimelineGraphKnobs,
	createDefaultOptions: (filteredProperties) => {
		return {
			options: {
				propertyList: [filteredProperties.find((property) => property.type === SrsPropertyType.Temporal).name],
				parameters: {
					stackProperty: [
						filteredProperties.find(
							(property) =>
								(property.flags.includes('Ordinal') || property.flags.includes(SrsPropertyFlag.Categorical)) &&
								!property.flags.includes(SrsPropertyFlag.Multivalued)
						).name,
					],
					maxBinResolution: 'Day',
					maxMajorBinCount: 1,
					maxMinorBinCount: 32,
				},
			},
		};
	},
	createDefaultConfiguration: (_filteredProperties) => {
		return {
			colorScale: DefaultChartColorScales.Categorical,
			stacked: true,
		};
	},
	isValid: (selectedDefinitionName) => {
		return filterProperties(selectedDefinitionName, [], types).length >= 1;
	},
};
